import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    headerRoot: {
        backgroundColor: "rgba(10, 25, 41, 0.72)",
    }
}))

export default useStyles;
